var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('settings-toolbar',{attrs:{"title":"Compensation Schedule"}}),_c('collective-agreements-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }